
import packageJson from "../../../../../package.json"; // Adjust the path as needed

const AppVersion = () => {
  return <div>App Version: {packageJson.version}</div>;
};

export default AppVersion;
